'use strict';

export default function chartConfig(scope) {
  'ngInject';
  
  let chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function() {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.series = this.series[0];
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: { text: '時間毎の電力量料金' },
    legend: { enabled: false },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      max: scope.categories.length - 1
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量料金 [円]'
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function(){
        var tip_format = "<tspan style='font-size: 12px'>" + this.x + "</tspan>";

        angular.forEach(this.points, function(point, i) {
          tip_format += '<br/><span style="color:'+ point.series.color +';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + point.series.name + ': ';
          if(scope.isMissingTime(point.x)){
            tip_format += "データ無し";
          } else if(scope.isNoCalculateTime(point.x)) {
            tip_format += "差分計算不可";
          } else {
            tip_format += scope.filter('decimalFilter')(point.y, 1) + " 円";
          }
          tip_format += "</span>"
        });

        return tip_format;
      }
    },
    series: [
      {
        name: '電力量料金',
        color: '#FFC107'
      }
    ],
    plotOptions: { column: { grouping: false } }
  };
  return chartConfig;
}



// WEBPACK FOOTER //
// ./public/dev/app/price_report/daily/daily_price_report.config.js